// extracted by mini-css-extract-plugin
export default {"root":"PowerBIReports_root__pyuT6","card":"PowerBIReports_card__vriJj","report":"PowerBIReports_report__wwGZ7","pdf":"PowerBIReports_pdf__-iEg2","icon":"PowerBIReports_icon__8HkZT"};